import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BaseResponse } from '../../models/response/base-response';

enum posicaoMensagem {
  topRight = 'top-right',
  topLeft = 'top-left',
  bottomRight = 'bottom-right',
  bottomLeft = 'bottom-left',
  topCenter = 'top-center',
  bottomCenter = 'bottom-center',
  center = 'center'
}

enum severity {
  sucesso = 'success',
  erro = 'error',
  info = 'info',
  aviso = 'warning'
}

class Message {
  severity?: string;
  summary?: string;
  detail?: string;
  id?: any;
  key?: string;
  life?: number;
  sticky?: boolean;
  closable?: boolean;
  data?: any;
  icon?: string;
}

@Injectable({
  providedIn: 'root'
})

export class AvisoService {

  constructor(private readonly messageService: MessageService) { }

  abrirBaseResponse<T>(
    baseResponse: BaseResponse<T>,
    titulo?: string,
    posicao?: posicaoMensagem,
    gravidade?: severity,
    tempo: number = 2
  ) {
    if (baseResponse.status) {
      this.Sucesso(baseResponse.mensagem, undefined, undefined, undefined, tempo);
    } else {
      this.Erro(baseResponse.mensagem, undefined, undefined, undefined, tempo);
    }
  }

  Erro(mensagem: string, titulo: string = 'Erro', posicao: posicaoMensagem = posicaoMensagem.topRight, gravidade: severity = severity.erro, tempo: number = 3): void {
    this.messageService.add({
      severity: gravidade,
      summary: titulo,
      detail: mensagem,
      life: tempo * 1000
    });
  }

  Info(mensagem: string, titulo: string = 'Atenção', posicao: posicaoMensagem = posicaoMensagem.topRight, gravidade: severity = severity.info, tempo: number = 3): void {
    this.messageService.add({
      severity: gravidade,
      summary: titulo,
      detail: mensagem,
      life: tempo * 1000
    });
  }

  Sucesso(mensagem: string, titulo: string = 'Sucesso', posicao: posicaoMensagem = posicaoMensagem.topRight, gravidade: severity = severity.sucesso, tempo: number = 3): void {
    this.messageService.add({
      severity: gravidade,
      summary: titulo,
      detail: mensagem,
      life: tempo * 1000
    });
  }
}
